function normalizeLeadId(value) {
  if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value.trim()))) {
    return null
  }
  const leadId = Number(value)
  return Number.isInteger(leadId) && leadId > 0 ? leadId : null
}

function createLeadContext(leadId, generation) {
  return {
    leadId: normalizeLeadId(leadId),
    generation
  }
}

function isActiveLeadContext(context, leadId, generation) {
  return Boolean(
    context
    && context.leadId
    && context.leadId === normalizeLeadId(leadId)
    && context.generation === generation
  )
}

function withValidLeadId(value, request) {
  const leadId = normalizeLeadId(value)
  if (leadId) return request(leadId)
  return Promise.reject(new TypeError('A valid numeric lead ID is required'))
}

module.exports = {
  createLeadContext,
  isActiveLeadContext,
  normalizeLeadId,
  withValidLeadId
}
